export default __webpack_public_path__ + "static/soap-ui-85f57655c17df5dac376593bf81abf16.svg";